import { useCallback, useRef } from "react";
import { acceptInvite } from "@/api/client";
import { useAuthStore } from "@/stores/auth";
import { AcceptInviteFlow } from "@/components/AcceptInviteFlow";

export function AcceptInvitePage() {
  const loadOrganizations = useAuthStore((s) => s.loadOrganizations);
  const orgCountRef = useRef(useAuthStore.getState().organizations.length);

  const handleSuccess = useCallback((_data: unknown) => {
    loadOrganizations();
  }, [loadOrganizations]);

  const handleError = useCallback(async () => {
    await loadOrganizations();
    const newCount = useAuthStore.getState().organizations.length;
    return newCount > orgCountRef.current;
  }, [loadOrganizations]);

  return (
    <AcceptInviteFlow
      returnPath="/accept-invite"
      title="Organization Invite"
      subtitle="Sign in or create an account to accept this invite."
      acceptFn={acceptInvite}
      onSuccess={handleSuccess}
      onError={handleError}
      successMessage="You've joined the organization."
      successLink="/dashboard"
      successLabel="Go to Dashboard"
    />
  );
}
